// extracted by mini-css-extract-plugin
export default {"fullScreen":"PricingDetails_fullScreen__2lrQ0","fullScreenBtn":"PricingDetails_fullScreenBtn__+KvsO"};